import { useEffect } from 'react'
import useCookieConsent from '@App/common/hooks/use-cookie-consent'
import { configureDatadog, isDatadogInitialized, setDatadogTrackingConsent } from '@App/configs/datadog-config'
import { configuration } from '@App/configs'

const useDatadogConsent = () => {
    const hasStatisticsConsent = useCookieConsent('statistics')

    useEffect(() => {
        if (!configuration.datadog_app_id) {
            return
        }

        if (!isDatadogInitialized()) {
            if (hasStatisticsConsent) {
                configureDatadog()
            }
            return
        }

        setDatadogTrackingConsent(hasStatisticsConsent)
    }, [hasStatisticsConsent])
}

export default useDatadogConsent
